import { Box, Flex } from "@chakra-ui/react";
import { buildPieChartStyles } from "./utils";
import PieChartText from "./PieChartText";
import type { PieChartProps } from "./PieChart.d";

const PieChartSecondary = ({ variant, text, chartValue }: PieChartProps) => {
  const customStyles = { paragraph: { fontSize: { base: "md", lg: "xl" } } };

  return (
    <Flex flexDirection="column" alignItems="center" w="100%" h="100%">
      <PieChartText text={text} styles={customStyles} />
      <Box mt="auto">
        <Box sx={buildPieChartStyles(variant, chartValue)} />
      </Box>
    </Flex>
  );
};
export default PieChartSecondary;
